module.exports = __webpack_public_path__ + "img/no-active.e2692109.png";